import {createAction} from 'redux-act'

export const setTransferCommissionModalVisible = createAction('SET_TRANSFER_COMMISSION_MODAL_VISIBLE')
export const setTransferCommissionForm = createAction('SET_TRANSFER_COMMISSION_FORM')
export const setTransferId = createAction('SET_TRANSFER_COMMISSION_TRANSFER_ID')



